module.exports = __webpack_public_path__ + "img/icon-spatial.467a61b1.png";